<!-- @format -->

<div class="app-paginator">
  <div class="paginator-text">
    <ng-container *ngIf="length">

      {{ _common.paginator?.showing }}
      {{ pageIndex * pageSize + 1 }}
      -
      {{ lastItem }}
      {{ _common.paginator.of }}
    </ng-container>
    {{ length }} {{ _common.paginator.results }}
    <!--({{ pageCount }} Pages)-->
  </div>
  <div>
    <ng-content></ng-content>
  </div>
  <div class="spacer"></div>
  <!-- <a
    [class.disabled_page]="!hasPrev()"
    (click)="firstPage()"
    class="paginator-button"
  >
    <fa-icon icon="angle-double-left"></fa-icon>
  </a> -->

  <a [class.disabled_page]="!hasPrev()" (click)="prevPage()" class="paginator-button">
    <fa-icon icon="angle-left"></fa-icon>
  </a>
  <a *ngIf="pageIndex > prevOffset.length" (click)="firstPage()" class="paginator-button">
    1
  </a>

  <div *ngIf="pageIndex - prevOffset.length - 1 >= 0">...</div>

  <ng-container *ngFor="let offset of prevOffset">
    <ng-container *ngIf="pageIndex - offset >= 0">
      <a (click)="move(pageIndex - offset)" class="paginator-page">
        {{ pageIndex - offset + 1 }}
      </a>
    </ng-container>
  </ng-container>

  <a class="paginator-current-page paginator-page"> {{ pageIndex + 1 }} </a>

  <ng-container *ngFor="let offset of offset">
    <ng-container *ngIf="pageIndex + offset < pageCount">
      <a (click)="move(pageIndex + offset)" class="paginator-page">
        {{ pageIndex + offset + 1 }}
      </a>
    </ng-container>
  </ng-container>

  <div *ngIf="pageIndex + offset.length + 1 < pageCount">...</div>
  <a *ngIf="pageIndex + offset.length + 1 < pageCount" (click)="lastPage()" class="paginator-button">
    {{ pageCount }}
  </a>
  <a [class.disabled_page]="!hasNext()" (click)="nextPage()" class="paginator-button">
    <fa-icon icon="angle-right"></fa-icon>
  </a>
  <!-- <a
    [class.disabled_page]="!hasNext()"
    (click)="lastPage()"
    class="paginator-button"
  >
    <fa-icon icon="angle-double-right"></fa-icon>
  </a> -->
  <div>
    {{ _common.paginator.GoTo }}
    <input style="width: 2rem; border: 1px solid #707070" [(ngModel)]="gotoPage" (keydown.enter)="goto()"
      type="number" />
  </div>
  <div (click)="goto()" class="cursor-pointer" style="margin-left: 5px; font-size: 14px">
    <fa-icon icon="circle-arrow-right"></fa-icon>
  </div>
</div>